export const maritalStatus = [
  { id: '1', name: 'Solteiro(a)' },
  { id: '2', name: 'Casado(a)' },
  { id: '3', name: 'Separado(a)' },
  { id: '4', name: 'Divorciado(a)' },
  { id: '5', name: 'Viuvo(a)' },
];
